import * as React from "react";
import { IScore } from "../../../store/credit/types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { creditFactors } from "../../../util/CreditScoreFactors";

interface IProps {
    factors?: IScore[];
}

const ScoreFactor: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const translateCreditFactors = (factor) => {
        const matchedFactor = creditFactors.find(el => el.key.toLowerCase() === factor.toLowerCase());
        if (matchedFactor && (preferencedLanguage === 'fr')) {
            return matchedFactor.value;
        }
        return factor;
    };
    return (
        <div className="card-body">
            {props.factors != null && (
                <React.Fragment>
                    {props.factors.map((factor) => (
                        <React.Fragment key={factor.abbreviation}>
                            {factor["score-factor-list"] != null && factor["score-factor-list"].length > 0 && (
                                <React.Fragment>
                                    <h4> {tLang("credit.creditScore.creditScoreWidget.label.scoreFactor", { serviceName: factor.abbreviation })}</h4>
                                    <p>{tLang("credit.creditScore.creditScoreWidget.label.scoreFactorDescription", { abbreviation: factor.abbreviation })}</p>

                                    <ul className="list-default list-condensed">
                                        {factor["score-factor-list"].map((soreFactor, index: number) => (
                                            <li key={index}>{translateCreditFactors(soreFactor)}</li>
                                        ))}
                                    </ul>
                                </React.Fragment>
                            )}
                            <br />
                        </React.Fragment>
                    ))}
                </React.Fragment>
            )}
        </div>
    );
};

export default ScoreFactor;
